<template>
  <div class="BoisDeChauffagePage">
    <div class="container">
      <div class="card shadow-lg p-4">

        <h2 class="text-center mb-4">Bois de Chauffage</h2>
        <div class="row">
          <div class="col-md-6 mb-3">
            <img src="@/assets/bois-chauffage.jpg" alt="Bois de Chauffage" class="img-fluid rounded shadow" />
          </div>
          <div class="col-md-6">
            <p class="fs-5">
              Notre bois de chauffage provient exclusivement des <strong>forêts belges</strong>.<br>
              Il est coupé en grume de <strong>2 ou 4 mètres</strong> puis séché naturellement pendant <strong>au moins
                2 ans</strong> dans nos dépôts.<br>
              <strong>Résultat :</strong> un bois parfaitement sec, prêt à l’emploi dès la livraison.
            </p>
            <p class="fs-5 text-primary">
              💡 Astuce malin : commandez au <strong>printemps ou en été</strong>, les tarifs sont toujours plus
              avantageux qu’en période hivernale.
              De plus vos bûches ont encore plus de temps pour sécher avant la saison!
            </p>

            <div class="alert alert-info mt-3">
              <strong>Longueurs disponibles :</strong> 30-35 cm · 40-45 cm · 50-55 cm<br>
              <strong>Essences :</strong> Hêtre · Frêne · Chêne · Charme · Merisier · Erable · Acacia<br>
              <strong>Tarif sur demande :</strong> Contactez-nous pour une offre personnalisée selon vos besoins et
              votre zone de livraison. <br>
            </div>

            <div class="alert alert-warning mt-3">
              <strong>Livraison gratuite</strong> pour toute commande dans un rayon de <strong>10 km</strong> autour de
              notre dépôt à <strong>Malèves-Sainte-Marie</strong> (Perwez).<br>
              Toujours en vrac, directement chez vous.<br>
              Livraison possible jusqu’à <strong>50 km</strong> – tarif sur demande.
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center">
          <a href="/public/contact" class="btn btn-primary mt-3">
            Nous contacter
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'BoisDeChauffagePage',
  components: {}
}
</script>
